export const scrollToElement = (elementId: string) => {
  const element = document.getElementById(elementId);

  if (element) {
    const elementRect = element.getBoundingClientRect();
    const elementTop = elementRect.top;
    const elementBottom = elementRect.bottom;

    if (elementTop < 0 || elementBottom > window.innerHeight) {
      element.scrollIntoView({behavior: "smooth"});
    }
  }
};
